const IMG_URL = 'http://goapi.sambapos.com/api/v1/uploads/';
const API_URL = 'https://goapi.sambapos.com/api/v1/';

export {
  IMG_URL,
  API_URL,
};
